// React and Next.js imports
import type { GetStaticProps } from "next";
import { useEffect, useRef } from "react";
import { useRouter } from "next/router";

// Builder.io imports

import type { BasePageProps } from "@orlandohealth/build-kit";
import { GenericPage } from "@orlandohealth/build-kit";
import { GenericWrapper } from "@orlandohealth/build-kit";
import { getLocaleRedirectPath } from "@orlandohealth/utils";

const Page = GenericPage.createPage(GenericWrapper);

function getPreferredLanguageCookie() {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(/(?:^|; )preferred_language=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : undefined;
}

const IndexWithLocaleRedirect = (props: any) => {
  const router = useRouter();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;
    const preferredLanguage = getPreferredLanguageCookie();
    const supportedLocales = ["en-US", "es"];
    const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE || "en";
    const redirectPath = getLocaleRedirectPath({
      pathname: router.asPath,
      preferredLanguage,
      supportedLocales,
      defaultLocale,
    });

    if (redirectPath && router.asPath !== redirectPath) {
      hasRedirected.current = true;
      router.replace(redirectPath);
    }
  }, [router]);
  return <Page {...props} />;
};

export const getStaticProps: GetStaticProps<BasePageProps> = async ({
  locale,
  defaultLocale,
}) => {
  return GenericPage.getStaticProps("/", locale, defaultLocale, "page");
};

export default IndexWithLocaleRedirect;
